import { PayloadAction, createSlice } from "@reduxjs/toolkit";
interface IPermissions {
  create: boolean;
  read: boolean;
  update: boolean;
  publish: boolean;
}

export interface NewCarAdminSidebar {
  collections: { [key: string]: IPermissions };
  singleType: { [key: string]: IPermissions };
  blog: { [key: string]: IPermissions };
  banner: { [key: string]: IPermissions };
  page: { [key: string]: IPermissions };
  configs: {
    [key: string]: IPermissions;
  };
}
export interface ISideBarAccess {
  hasAccessData: boolean;
  fetchedAccessData: boolean;
  accessData: NewCarAdminSidebar;
}

const initialState: ISideBarAccess = {
  fetchedAccessData: false,
  hasAccessData: false,
  accessData: {
    collections: {},
    singleType: {},
    configs: {},
    blog:{},
    banner:{},
    page:{}
  },
};

export const sideBarAccessSlice = createSlice({
  name: "sideBarAccess",
  initialState,
  reducers: {
    setSideBarAccessInfoFetched: (state) => {
      state.fetchedAccessData = true;
    },
    setSideBarAccessInfo: (state, action: PayloadAction<ISideBarAccess>) => {
      state.hasAccessData = action.payload.hasAccessData;
      state.accessData = action.payload.accessData;
      state.fetchedAccessData = action.payload.fetchedAccessData;
    },
    resetSideBarAccessInfo: (state) => {
      state.fetchedAccessData = initialState.fetchedAccessData;
      state.hasAccessData = initialState.hasAccessData;
      state.accessData = initialState.accessData;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSideBarAccessInfo,
  resetSideBarAccessInfo,
  setSideBarAccessInfoFetched,
} = sideBarAccessSlice.actions;

export default sideBarAccessSlice.reducer;
